module.exports = __webpack_public_path__ + "static/qh_21.f290146d.jpg";